import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../images/locationgcc/qa/teemates.webp";
import Img2 from "../../images/locationgcc/dxb/img_case_02.webp";
import Img3 from "../../images/locationgcc/dxb/img_case_03.webp";

const CaseStudy = [
  {
    title: "TeeMates",
    description:
      "Teemates simplify the process of playing & engaging with fellow golf enthusiasts, offering a seamless and convenient platform, enabling you to connect with individuals sharing similar interests.",
    link: "teemates",
    Img: Img1,
    BgColor: "#738E45",
    TextColor: "#FFFFFF",
  },
  {
    title: "Selah",
    description:
      "Selah is a social app designed to connect and interact with friends and family.",
    link: "saleh",
    Img: Img2,
    BgColor: "#00ADEF",
    TextColor: "#FFFFFF",
  },
  {
    title: "Nurse",
    description:
      "The Nurse Practitioners application was built for a very specific reason – to revolutionize the healthcare system and convey the positive impact of technology to the end users.",
    link: "nurse-practitioners",
    Img: Img3,
    BgColor: "#6747C2",
    TextColor: "#FFFFFF",
  },
];

const StoriesCase = () => {
  return (
    <div className="case_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Startup App Clients We've Served</h2>
            <p>
              Over the years, we have paved the way for several startup brands
              with our app development.
            </p>
          </Col>
        </Row>
        <Row>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    View Full Casestudy
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoriesCase;
